import Phaser from "phaser";
import LoadingScene from "@/games/Fishing/scenes/LoadingScene";
import QuestionScene from "@/games/Fishing/scenes/QuestionScene";
import BeforeQuestionScene from "@/games/Fishing/scenes/BeforeQuestionScene";
import AfterQuestionScene from "@/games/Fishing/scenes/AfterQuestionScene";
import BossScene from "@/games/Fishing/scenes/BossScene";
import LandingScene from "@/games/Fishing/scenes/LandingScene";
import Settings from "@/games/Fishing/scenes/Settings";
import Recommendation from "@/games/Fishing/scenes/Recommendation";


function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      BeforeQuestionScene,
      AfterQuestionScene,
      BossScene,
      Settings,
      Recommendation,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
